import { useContext, useEffect, useState } from "react";
import axios from "axios";
import Style from "./style";
import { WalletContext } from "../../scripts/context/WalletContext";
import toast from "react-hot-toast";

export default function Commission() {
  const { web3 } = useContext(WalletContext);
  const { contract } = web3.contracts.affiliateCommissions;
  const [commission, setCommission] = useState({});
  const [loading, setLoading] = useState(true);
  const [claiming, setClaiming] = useState(false);

  const bigNumberToFixed = (value) =>
    parseFloat(value?.toString() / Math.pow(10, web3.decimals)).toFixed(4);

  const CLAIMED_PROGRESSBAR =
    Number(bigNumberToFixed(commission.commissionsClaimed_)) > 0
      ? Number(
          (Number(bigNumberToFixed(commission.commissionsClaimed_)) /
            Number(bigNumberToFixed(commission.totalAffiliateCommissions_))) *
            100
        )
      : 0.0;

  useEffect(() => {
    if (Object.keys(commission).length) return;

    setLoading(true);
    Promise.all([
      axios.get("/wallet/get-commission-info"),
      contract.getClaimer(),
    ]).then(([getCommissionAPI, claimer]) => {
      setCommission({
        ...getCommissionAPI.data.data,
        availableCommissionsAmount_: claimer.availableCommissionsAmount_,
        commissionsClaimed_: claimer.commissionsClaimed_,
        nextUnlockDate_: claimer.nextUnlockDate_,
        totalAffiliateCommissions_: claimer.totalAffiliateCommissions_,
      });

      setLoading(false);
    });

    return () => {
      setCommission({});
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const claimCommission = async () => {
    setClaiming(true);

    try {
      const isClaimed = await contract.claimCommissions({
        from: web3.account.address,
      });
      toast.promise(
        isClaimed.wait().then(async () => {
          const claimer = await contract.getClaimer();
          setCommission({
            ...commission,
            availableCommissionsAmount_: claimer.availableCommissionsAmount_,
            commissionsClaimed_: claimer.commissionsClaimed_,
            nextUnlockDate_: claimer.nextUnlockDate_,
            totalAffiliateCommissions_: claimer.totalAffiliateCommissions_,
          });
        }),
        {
          loading: "claiming...",
          success: `You claimed tokens`,
          error: (error) => error.message,
        }
      );
    } catch (error) {
      console.log(error);
    }
    setClaiming(false);
  };

  if (loading)
    return (
      <div className="row" style={{ height: "434.797px" }}>
        <div className="col-md-5 mx-auto mt-0">
          <div
            className="card card-custom gutter-b card-stretch"
            style={{ background: "unset" }}
          >
            <span className="loading-row full-height full-width" />
          </div>
        </div>
      </div>
    );

  return (
    <>
      <Style>
        <div className="container">
          <div className="row margin-top-10px">
            <div className="col-md-7">
              <div>
                <div className="card card-custom card-stretch">
                  <div className="card-spacer card-rounded flex-grow-1">
                    <div className="d-flex justify-content-between">
                      <div className="d-flex flex-column flex-wrap">
                        <div className="full-width max-w-150px px-0 py-3 mr-4">
                          <div className="font-size-sm text-muted font-weight-bold">
                            Commission Claimed
                          </div>
                          <div className="font-size-h6 font-weight-bolder">
                            {bigNumberToFixed(commission.commissionsClaimed_)}{" "}
                            $BULT
                          </div>
                        </div>
                        <div className="full-width max-w-150px px-0 py-3 mr-4">
                          <div className="font-size-sm text-muted font-weight-bold">
                            Of
                          </div>
                          <div className="font-size-h6 font-weight-bolder">
                            {bigNumberToFixed(commission.totalAffiliateCommissions_)} $BULT
                          </div>
                        </div>
                      </div>
                      <div className="d-flex flex-column flex-wrap">
                        <div className="full-width max-w-180px px-0 py-3 mr-4">
                          <div className="font-size-sm text-muted font-weight-bold">
                            No. of Affiliates
                          </div>
                          <div className="font-size-h4 font-weight-bolder">
                            {commission.affiliate_count}
                          </div>
                        </div>
                        <div className="full-width max-w-180px px-0 py-3 mr-4">
                          <div className="font-size-sm text-muted font-weight-bold">
                            Next Unlock:
                          </div>
                          <div className="font-size-h6 font-weight-bolder">
                            {new Date(
                              commission.nextUnlockDate_?.toString() * 1000
                            ).toLocaleString()}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="d-flex flex-column w-100 mt-10">
                      <div className="progress progress-xs w-100">
                        <div
                          className="progress-bar bg-progress-custom"
                          role="progressbar"
                          aria-valuenow="0"
                          aria-valuemin="0"
                          aria-valuemax="100"
                          style={{
                            width: `${CLAIMED_PROGRESSBAR}%`,
                          }}
                        ></div>
                      </div>
                      <div className="d-flex justify-content-between">
                        <div className="d-flex flex-column flex-wrap">
                          <span className="text-muted mr-2 font-size-sm font-weight-bold">
                            {CLAIMED_PROGRESSBAR.toFixed(2)}%
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card card-custom card-stretch mt-5">
                  {[
                    {
                      text: "Claimed",
                      value: bigNumberToFixed(commission.commissionsClaimed_),
                    },
                    {
                      text: "Ready to claim",
                      value: bigNumberToFixed(
                        commission.availableCommissionsAmount_
                      ),
                    },
                    {
                      text: "Locked Commission",
                      value: Math.abs(
                        Number(
                          bigNumberToFixed(commission.totalAffiliateCommissions_) -
                            bigNumberToFixed(commission.commissionsClaimed_) -
                            bigNumberToFixed(
                              commission.availableCommissionsAmount_
                            )
                        )
                      ).toFixed(4),
                    },
                  ].map(({ text, value }, index) => (
                    <div
                      key={index}
                      className="d-flex align-items-center justify-content-between py-4 px-7 border-bottom"
                    >
                      <div className="font-size-sm text-muted font-weight-bold">
                        {text}
                      </div>

                      <div className="d-flex align-items-center gap-1">
                        <svg
                          width="16"
                          height="10"
                          viewBox="0 0 20 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            opacity="0.75"
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M0 5.83333H15.7444L11.7667 1.645L13.3333 0L20 7L13.3333 14L11.7667 12.355L15.7444 8.16667H0V5.83333Z"
                            fill="#C8DCFB"
                          />
                        </svg>

                        <span>{value}</span>
                      </div>
                    </div>
                  ))}
                  <div className="d-flex align-items-center justify-content-between py-4 px-7">
                    <div className="font-size-lg font-weight-boldest">
                      Total Commissions
                    </div>

                    <div className="d-flex align-items-center gap-1">
                      <svg
                        width="16"
                        height="10"
                        viewBox="0 0 20 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          opacity="0.75"
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M0 5.83333H15.7444L11.7667 1.645L13.3333 0L20 7L13.3333 14L11.7667 12.355L15.7444 8.16667H0V5.83333Z"
                          fill="#C8DCFB"
                        />
                      </svg>

                      <span className="font-size-lg font-weight-boldest">
                        {commission.total_commission}
                      </span>
                    </div>
                  </div>
                </div>
                <button
                  className="w-100 btn btn-primary-custom mt-5"
                  disabled={
                    claiming ||
                    !Number(
                      bigNumberToFixed(commission.availableCommissionsAmount_)
                    )
                  }
                  onClick={claimCommission}
                >
                  Claim{" "}
                  {bigNumberToFixed(commission.availableCommissionsAmount_)}{" "}
                  $BULT
                </button>
              </div>
            </div>

            <div className="col-md-5">
              <div className="commission-rate-component">
                <div>
                  <div className="font-size-sm font-weight-bold key">
                    Commission Rate
                  </div>
                  <div className="font-size-h3 font-weight-bolder value">
                    {(commission.commission_rate * 100).toFixed(2)}%
                  </div>
                </div>

                <img src="/img/commission-rate.svg" alt="commission-rate" />
              </div>

              <div className="card card-custom px-7 py-2 mt-5 affiliates-component">
                <div className="d-flex align-items-center justify-content-between">
                  <span className="font-size-lg text-muted font-weight-bold">
                    Affiliates
                  </span>
                  <span>{commission.affiliate_count}</span>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-between">
                  <span className="font-size-lg text-muted font-weight-bold">
                    Owned
                  </span>
                  <span>
                    {Number(Number(commission.total_commission) * 10).toFixed(
                      4
                    )}{" "}
                    $BULT
                  </span>
                </div>
              </div>

              <div className="my-commission-card-component">
                <div>
                  <div className="font-size-sm font-weight-bol key">
                    YOUR Commission
                  </div>
                  <div className="font-size-h3 font-weight-bolder value">
                    {bigNumberToFixed(commission.totalAffiliateCommissions_)} $BULT
                  </div>
                </div>

                <img src="/img/user-with-percent.png" alt="commission-rate" />
              </div>
            </div>
          </div>
        </div>
      </Style>
    </>
  );
}
